<template>
    <div>
        <div v-if="authorArticles.articles == null">
            <div class="post-moudle__release">
                <div class="empty-data">暂无数据</div>
            </div>
        </div>
        <div v-else>
            <div style="margin-bottom:24px;margin-top:-8px;">
                <div class="article-item-warp" v-for="item in authorArticles.articles" :key="item.id">
                    <div class="article-item bbt-clearfix">
                        <div class="article-item__thumb">
                            <a href="javascript:;" target="_blank" class="">
                            <img :src="item.imagUrl" lazy="loaded">
                            </a>
                        </div>
                        <div class="article-item__body">
                            <h3 class="article-item__title">
                                <router-link :to="{path:'/articleDetail/' + item.id}" target="_blank" class="link-dark-major font-bold bbt-block">
                                    {{item.title}}
                                </router-link>
                            </h3>
                            <div class="article-item__content" v-html="item.content"></div>
                            <div class="article-item__info bbt-clearfix">
                                <div class="article-item__author">
                                    <router-link :to="{path:'/authorDetail/' + item.authorId}" target="_blank" class="link-dark-major article-item__author-name">
                                    {{item.author}}
                                    </router-link>
                                    {{ $filters.formatDate(item.createTime) }}
                                    <span v-if="item.tags != ''">
                                        <a href="javascript:;" 
                                            class="bbt-tag bbt-tag--flame  bbt-tag--sm" v-for="tag in item.tags.split(',')" v-bind:key="tag">
                                            {{tag}}
                                        </a>
                                    </span>
                                </div>
                                <div class="article-item__data">
                                    <span><i class="el-icon-view"></i> {{item.viewCount}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bbt-row" style="margin-left:-12px;margin-right:-12px;" v-if="authorArticles.articles.length == 6">
                <div class="bbt-col-xs-24" style="padding-left:12px;padding-right:12px;">
                    <div class="bbt-btn bbt-btn--default bbt-btn--lg bbt-btn-block" @click="loadMoreArticle" v-if="hasMoreArticle">
                        查看更多
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'UserDetailArticle',
    props:{
        serveHost: String
    },
    data() {
        return {
            pagNo:1,
            showApplyPost:0,
            authorArticles:{},
            hasMoreArticle:true,
            user:{}
        }
    },
    methods: {
        loadMoreArticle:function() {
            // 文章列表更多加载
            this.pagNo++
            this.loadArticleList(this, this.pagNo);
        },
        loadDataByAsync:function(URL, DATA, CALLBACK_FUNC) {
            $.get(URL, DATA, CALLBACK_FUNC);
        },
        loadArticleList:function(_vm, pagNo) {
            var aysnUrl = ''
            if(this.$route.query.p === 'post') {
                aysnUrl = "/api/v1/user/mainpost/" + _vm.authorArticles.author.authorId + "/" + _vm.pagNo;
            } else {
                aysnUrl = "/api/v1/article/author/" + _vm.authorArticles.author.authorId + "/" + _vm.pagNo;
            }
            // 新闻列表
            this.loadDataByAsync(_vm.serveHost + aysnUrl, function(r){
                if(r.code != "2000000") {
                    console.error('get author articles error.');
                    _vm.hasnotArticle(_vm);
                    return;
                }
                if(r.data.articles) {
                    r.data.articles.forEach((item, index) => {
                        _vm.authorArticles.articles.push(item);
                    });
                    _vm.articleLoad = false;
                    _vm.hasMoreArticle = true;
                } else {
                    _vm.hasnotArticle(_vm);
                }
            });
        },
        hasnotArticle(_vm) {
            _vm.hasMoreArticle = false;
            _vm.$alert('没有更多文章了', '提示', {
                type:'warning',
                closeOnClickModal:true,
                closeOnPressEscape:true,
                confirmButtonText: '确定',
                callback: action => {
                    
                }
            });
        }
    },
    created() {
        var _vm = this;
        this.user = JSON.parse(localStorage.user)

        _vm.loadDataByAsync(_vm.serveHost + '/api/v1/article/author' + '/' + this.user.userid + '/1', function(r){
            if(r.code != "2000000") {
                console.error('get articles error.');
                return;
            }
            _vm.authorArticles = r.data;
        });
    }
}
</script>

<style scoped>
.empty-data {
    margin: 0 auto;
    padding: 50px;
    color: rgba(0,0,0,.32);
    font-size: 14px;
    line-height: 22px;
    text-align: center;
}
</style>